import {Component, Input, OnInit} from '@angular/core';
import {ShipmentService} from "../../../../../../open-api-generated/services/shipment.service";
import {ShipmentHistoryRow} from "../../../../../../open-api-generated/models/shipment-history-row";
import {ParcelHistory} from "../../../../../../open-api-generated/models/parcel-history";

@Component({
  selector: 'app-shipment-history-card',
  templateUrl: './shipment-history-card.component.html',
  styleUrls: ['./shipment-history-card.component.scss']
})
export class ShipmentHistoryCardComponent implements OnInit {
  @Input('internalNumber') public internalNumber: string = null;
  @Input('isAdmin') isAdmin: boolean = false;

  activeCardName: string = null;

  shipmentHistoryRows: ShipmentHistoryRow[] = [];

  parcelHistoryObjects: ParcelHistory[] = [];

  constructor(
    private shipmentService: ShipmentService,
  ) {

  }

  ngOnInit() {
    this.readHistory();
    setTimeout(
      (): void => {
        this.readHistory();
      }, 100
    );
  }

  handleStatusChangedEvent(): void {
    this.readHistory();
    setTimeout(
      (): void => {
        this.readHistory();
      }, 100
    );
  }

  readHistory() {
    this.shipmentService.appV2ShipmentHistory({internalNumber: this.internalNumber}).subscribe(
      (history: any): void => {
        this.shipmentHistoryRows = history.history.shipment;
        this.parcelHistoryObjects = history.history.parcels;
        if (null !== this.activeCardName) {
          return;
        }

        if (this.parcelHistoryObjects.length > 1) {
          this.activeCardName = 'common';
        }
        else {
          for (let objet of this.parcelHistoryObjects) {
            this.activeCardName = objet.waybill;
            return;
          }
        }
      }
    );
  }

  activeCardChanged(cardName: string): void {
    this.activeCardName = cardName;
  }
}
